export const ATTENTION_PULSE_DURATION_MS = 500

type HandleScrollButtonClickParams = {
    autoScrollMode: boolean
    pauseAutoScroll: () => void
    enterAutoScroll: (dto: { shouldFocusContainer: boolean }) => void
    startAttentionPulse: () => void
}

export const handleScrollButtonClick = ({
    autoScrollMode,
    pauseAutoScroll,
    enterAutoScroll,
    startAttentionPulse,
}: HandleScrollButtonClickParams): void => {
    if (autoScrollMode) {
        pauseAutoScroll()

        return
    }

    enterAutoScroll({ shouldFocusContainer: true })
    startAttentionPulse()
}
